// components/LocationPermissionModal.jsx
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box
} from "@mui/material";
import { LocationOn as LocationIcon } from "@mui/icons-material";

export const LocationPermissionModal = ({ 
  isOpen, 
  onClose, 
  onPermissionGranted,
  isRequesting 
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2
        }
      }}
    >
      <DialogContent>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <LocationIcon 
            sx={{ 
              fontSize: 48, 
              color: 'primary.main',
              mb: 2 
            }} 
          />
          <Typography variant="h6" fontWeight="600" gutterBottom>
            Permissão de Localização
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Para uma melhor experiência e segurança, precisamos da sua localização 
            para registrar a assinatura da ficha cadastral.
          </Typography>
        </Box>
        
        <Box sx={{ 
          backgroundColor: 'grey.50', 
          p: 2, 
          borderRadius: 2,
          mb: 2 
        }}>
          <Typography variant="caption" color="text.secondary">
            📍 Sua localização ajuda a validar a autenticidade da assinatura
          </Typography>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ borderRadius: 2, px: 3 }}
        >
          Cancelar
        </Button>
        <Button
          onClick={onPermissionGranted}
          variant="contained"
          disabled={isRequesting}
          sx={{ borderRadius: 2, px: 3 }}
        >
          {isRequesting ? 'Solicitando...' : 'Permitir Localização'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};